import { atom } from 'jotai'

/**
 * 車種マスタのインポートModalの表示状態
 */
export const isOpenTruckModelImportModalAtom = atom<boolean>(false)

isOpenTruckModelImportModalAtom.debugLabel = 'isOpenTruckModelImportModalAtom'
